import { useState } from "react";
import { faqs } from "@/mocks/anime";

export default function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-16">
      <div className="max-w-2xl">
        <span className="text-sm font-medium text-primary-600">FAQ</span>
        <h2 className="font-heading mt-1 text-2xl text-foreground-900 md:text-3xl">常见问题</h2>
        <p className="mt-3 text-sm leading-6 text-foreground-600">
          关于《秘密教学动漫》最常被问到的问题，这里一次性讲清楚。
        </p>
      </div>

      <div className="mt-8 space-y-3">
        {faqs.map((f, idx) => {
          const isOpen = open === idx;
          return (
            <div
              key={f.q}
              className="overflow-hidden rounded-lg border border-background-200 bg-background-50"
            >
              <button
                type="button"
                onClick={() => setOpen(isOpen ? null : idx)}
                aria-expanded={isOpen}
                className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left cursor-pointer"
              >
                <span className="text-sm font-medium text-foreground-900 md:text-base">{f.q}</span>
                <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors ${isOpen ? "bg-primary-500 text-background-50" : "bg-secondary-100 text-secondary-700"}`}>
                  <i className={`${isOpen ? "ri-subtract-line" : "ri-add-line"}`}></i>
                </span>
              </button>
              {isOpen && (
                <div className="border-t border-background-200 px-5 py-4">
                  <p className="text-sm leading-7 text-foreground-600">{f.a}</p>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
}